import React from "react";

const Tenth_Answer = () => {
  return (
    <>
      <div className="tenth_answer">
        <p>
          Please visit our website www.timecybermedia.com and fill in your
          nomination or leave us a message in our contact page and we will send
          you the nomination form. Alternatively you can call us on our helpline
          numbers: +91-9821020995, +91-98 73004416
        </p>
      </div>
    </>
  );
};

export default Tenth_Answer;
